module.exports = __webpack_public_path__ + "static/media/logo.0422be9b.svg";